var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import { Box, Divider, Grid, Stack, Typography, Button, Chip, Tooltip } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import CommonDialog from '../../components/uiComponents/CommonDialog';
import { api_service } from '../../api/api_service';
import { api_urls } from '../../api/api_urls';
import { utility } from '../../utils';
import moment from 'moment';
import { TruncatedTooltipText } from '../../components/uiComponents/TruncatedTooltipText';
import { useSelector } from 'react-redux';
import { baseColors } from '../../Themes/colors';
import TabSectionCard, { DataWrapper } from './components/TabSectionCard';
import { RESPONSIVE_FIELD_GRID_SX } from './utils/responsiveGrid';
var FICO_ALLOWED_ROLES = ["ADMIN", "CREDIT_MANAGER"];
var EQUIFAX_CODES = ['EQ', 'EFU', 'EC', 'EFX', 'ECC'];
var PAYNET_CODES = ['PN', 'PND', 'PDC'];
var getRoleBasedEquifaxFicoScore = function (item, roleType) {
    var canViewFicoScore = FICO_ALLOWED_ROLES.includes(roleType);
    return canViewFicoScore ? item.FicoScore : item.ApproxReportScoreRange;
};
var prepareDataByBureau = function (item, roleType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
    switch (item.BureauCode) {
        case 'PN':
        case 'PND':
        case 'PDC':
            return [
                { label: 'Master Score', value: item.MasterScore ? "".concat(item.MasterScore) : '--' },
                { label: 'Percentile', value: item.Percentile != null && item.Percentile != "" ? "".concat(item.Percentile) : '--' },
                { label: 'Original Gross Receivable', value: item.OriginalGrossReceivable != null && item.OriginalGrossReceivable != "" ? "$".concat(item.OriginalGrossReceivable.toLocaleString()) : '$0.00' },
                { label: 'Highest Credit Ever', value: item.HighestCreditEver != null && item.HighestCreditEver != "" ? "$".concat(item.HighestCreditEver.toLocaleString()) : '$0.00' },
                { label: 'Scheduled Payments', value: item.ScheduledPayments != null && item.ScheduledPayments != "" ? "".concat(item.ScheduledPayments) : '--' },
                { label: 'Average Term(Months)', value: item.AverageTerm != null && item.AverageTerm != "" ? "".concat(item.AverageTerm) : '--' },
                { label: 'Current Balance Amount', value: item.CurrentBalanceAmount != null && item.CurrentBalanceAmount != "" ? "$".concat(item.CurrentBalanceAmount.toLocaleString()) : (item.TotalOutstandingReceivable != null && item.TotalOutstandingReceivable != "" ? "$".concat(item.TotalOutstandingReceivable.toLocaleString()) : '$0.00') },
                { label: 'Current Balance PastDue 31+ Amount', value: item.CurrentBalancePastDue31PlusAmount != null && item.CurrentBalancePastDue31PlusAmount != "" ? "$".concat(item.CurrentBalancePastDue31PlusAmount.toLocaleString()) : '$0.00' },
                { label: 'PastDue 31+ Occurrences', value: item.PastDue31PlusOccurrences != null && item.PastDue31PlusOccurrences != "" ? "".concat(item.PastDue31PlusOccurrences) : '--' },
                { label: 'PastDue 31-60 Occurrences', value: item.PastDue3160Occurrences != null && item.PastDue3160Occurrences != "" ? "".concat(item.PastDue3160Occurrences) : '--' },
                { label: 'PastDue 61-90 Occurrences ', value: item.PastDue6190Occurrences != null && item.PastDue6190Occurrences != "" ? "".concat(item.PastDue6190Occurrences) : '--' },
                { label: 'PastDue 91+ Occurrences', value: item.PastDue91PlusOccurrences != null && item.PastDue91PlusOccurrences != "" ? "".concat(item.PastDue91PlusOccurrences) : '--' },
                { label: 'PastDue 31-60 Date ', value: item.MostRecentPastDue3160Date != null && item.MostRecentPastDue3160Date != "" ? moment(item.MostRecentPastDue3160Date).format('MM-DD-YYYY') : '--' },
                { label: 'PastDue 61-90 Date', value: item.MostRecentPastDue6190Date != null && item.MostRecentPastDue6190Date != "" ? moment(item.MostRecentPastDue6190Date).format('MM-DD-YYYY') : '--' },
                { label: 'PastDue 91+ Date', value: item.MostRecentPastDue91PlusDate != null && item.MostRecentPastDue91PlusDate != "" ? moment(item.MostRecentPastDue91PlusDate).format('MM-DD-YYYY') : '--' },
                { label: 'Highest Amount Borrowed From One Lender', value: item.HighestAmountBorrowedFromOneLender != null && item.HighestAmountBorrowedFromOneLender != "" ? "$".concat(item.HighestAmountBorrowedFromOneLender.toLocaleString()) : '$0.00' },
                { label: 'Avg High Credit Per Lender', value: item.AverageHighCreditPerLendar != null && item.AverageHighCreditPerLendar != "" ? "$".concat(item.AverageHighCreditPerLendar.toLocaleString()) : '$0.00' },
                { label: 'Open Contracts Count', value: item.OpenContractsCount != null && item.OpenContractsCount != "" ? item.OpenContractsCount : '--' },
                { label: 'Closed Contracts Count', value: item.ClosedContractsCount || '--' },
                { label: 'Date Requested', value: moment(item.DateRequested).format('MM-DD-YYYY') },
            ];
        case 'EQ':
        case 'EFU':
        case 'EC':
        case 'EFX':
        case 'ECC':
            var ficoScoreValue = getRoleBasedEquifaxFicoScore(item, roleType);
            return [
                { label: 'FICO Score', value: ficoScoreValue != null && ficoScoreValue !== '' ? ficoScoreValue : '--', },
                { label: 'Total Trades', value: item.TotalTrades != null && item.TotalTrades != '' ? item.TotalTrades : '--', },
                { label: 'Current Trades', value: item.CurrentTrades != null && item.CurrentTrades != '' ? item.CurrentTrades : '--', },
                { label: 'Occurrences 30', value: item.CURRENTRATING_30 != null && item.CURRENTRATING_30 != '' ? item.CURRENTRATING_30 : '--', },
                { label: 'Occurrences 60', value: item.CURRENTRATING_60 != null && item.CURRENTRATING_60 != '' ? item.CURRENTRATING_60 : '--', },
                { label: 'Occurrences 90', value: item.CURRENTRATING_90 != null && item.CURRENTRATING_90 != '' ? item.CURRENTRATING_90 : '--', },
                { label: 'Negative Trades History', value: item.NegativeTradesHistory != null && item.NegativeTradesHistory != '' ? item.NegativeTradesHistory : '--', },
                { label: 'Account Balance', value: item.AccountBalance != null && item.AccountBalance !== "" ? "$".concat(item.AccountBalance.toLocaleString()) : '$0.00', },
                { label: 'High Credit', value: item.HighCredit != null && item.HighCredit !== "" ? "$".concat(item.HighCredit.toLocaleString()) : '$0.00', },
                { label: 'Amount Past Due', value: item.AmountPastDue != null && item.AmountPastDue != "" ? "$".concat(item.AmountPastDue.toLocaleString()) : '$0.00', },
                { label: 'Credit Limit', value: item.CreditLimit != null && item.CreditLimit != "" ? "$".concat(item.CreditLimit.toLocaleString()) : '$0.00', },
                { label: 'Collections', value: item.Collections != null && item.Collections != "" ? item.Collections : '--', },
                { label: 'Installment Balance', value: item.InstallmentBalance != null && item.InstallmentBalance != '' ? "$".concat(item.InstallmentBalance.toLocaleString()) : '$0.00', },
                { label: 'Available Percentage', value: item.AvailablePercentage != null && item.AvailablePercentage != "" ? "".concat(item.AvailablePercentage, "%") : '0%' },
                { label: 'Real Estate Balance', value: item.RealEstateBalance != null && item.RealEstateBalance != "" ? "$".concat(item.RealEstateBalance.toLocaleString()) : '$0.00', },
                { label: 'Revolving Balance', value: item.RevolvingBalance != null && item.RevolvingBalance != "" ? "$".concat(item.RevolvingBalance.toLocaleString()) : '$0.00', },
                { label: 'Oldest Trade', value: item.OldestTrade ? moment(item.OldestTrade).format('MM-DD-YYYY') : '--', },
                { label: 'Primary Address', value: item.PrimaryAddressLine1 || item.PrimaryAddressLine2 ? "".concat((_a = item.PrimaryAddressLine1) !== null && _a !== void 0 ? _a : '', " ").concat((_b = item.PrimaryAddressLine2) !== null && _b !== void 0 ? _b : '').trim() : '--', },
                { label: 'Secondary Address', value: item.SecondaryAddressLine1 || item.SecondaryAddressLine2 ? "".concat((_c = item.SecondaryAddressLine1) !== null && _c !== void 0 ? _c : '', " ").concat((_d = item.SecondaryAddressLine2) !== null && _d !== void 0 ? _d : '').trim() : '--', },
                { label: 'Date Requested', value: item.DateRequested ? moment(item.DateRequested).format('MM-DD-YYYY') : '--', },
            ];
        case 'DB':
            return [
                {
                    groupName: 'Business Worksheet',
                    items: [
                        { label: 'Credit Report Score', value: (_f = (_e = item.BusinessWorkSheet) === null || _e === void 0 ? void 0 : _e.CreditReportScore) !== null && _f !== void 0 ? _f : '--' },
                        { label: 'Total Weighted Credit Score', value: (_h = (_g = item.BusinessWorkSheet) === null || _g === void 0 ? void 0 : _g.TotalWeightedCreditScore) !== null && _h !== void 0 ? _h : '--' },
                        { label: 'Weighted Scorecard Count', value: (_k = (_j = item.BusinessWorkSheet) === null || _j === void 0 ? void 0 : _j.WeightedScorecardBusinessCount) !== null && _k !== void 0 ? _k : '--' },
                        { label: 'Scored SIC Code', value: (_m = (_l = item.BusinessWorkSheet) === null || _l === void 0 ? void 0 : _l.ScoredSICCode) !== null && _m !== void 0 ? _m : '--' },
                    ]
                },
                {
                    groupName: 'Credit Bureau Data - Business Data',
                    items: [
                        { label: 'Report Code', value: (_q = (_p = (_o = item.CreditBureauData) === null || _o === void 0 ? void 0 : _o.BusinessData) === null || _p === void 0 ? void 0 : _p.ReportCode) !== null && _q !== void 0 ? _q : '--' },
                        { label: 'Risk Score Percentile', value: (_t = (_s = (_r = item.CreditBureauData) === null || _r === void 0 ? void 0 : _r.BusinessData) === null || _s === void 0 ? void 0 : _s.RiskScorePercentile) !== null && _t !== void 0 ? _t : '--' },
                        { label: 'Scored SIC Code', value: (_w = (_v = (_u = item.CreditBureauData) === null || _u === void 0 ? void 0 : _u.BusinessData) === null || _v === void 0 ? void 0 : _v.ScoredSICCode) !== null && _w !== void 0 ? _w : '--' },
                    ]
                },
                {
                    groupName: 'Credit Bureau Data - Analysis',
                    items: [
                        { label: 'Credit Risk Score', value: (_z = (_y = (_x = item.CreditBureauData) === null || _x === void 0 ? void 0 : _x.Analysis) === null || _y === void 0 ? void 0 : _y.CreditRiskScore) !== null && _z !== void 0 ? _z : '--' },
                        { label: 'Control Year', value: (_2 = (_1 = (_0 = item.CreditBureauData) === null || _0 === void 0 ? void 0 : _0.Analysis) === null || _1 === void 0 ? void 0 : _1.ControlYear) !== null && _2 !== void 0 ? _2 : '--' },
                        { label: 'Report Rating', value: (_5 = (_4 = (_3 = item.CreditBureauData) === null || _3 === void 0 ? void 0 : _3.Analysis) === null || _4 === void 0 ? void 0 : _4.ReportRating) !== null && _5 !== void 0 ? _5 : '--' },
                        { label: 'Commercial Credit Score', value: (_8 = (_7 = (_6 = item.CreditBureauData) === null || _6 === void 0 ? void 0 : _6.Analysis) === null || _7 === void 0 ? void 0 : _7.CommercialCreditScore) !== null && _8 !== void 0 ? _8 : '--' },
                        { label: 'Business Start Date', value: (_11 = (_10 = (_9 = item.CreditBureauData) === null || _9 === void 0 ? void 0 : _9.Analysis) === null || _10 === void 0 ? void 0 : _10.BusinessStartDate) !== null && _11 !== void 0 ? _11 : '--' },
                        { label: 'Paydex Norm', value: (_14 = (_13 = (_12 = item.CreditBureauData) === null || _12 === void 0 ? void 0 : _12.Analysis) === null || _13 === void 0 ? void 0 : _13.PaydexNorm) !== null && _14 !== void 0 ? _14 : '--' },
                        { label: 'Current Paydex Score', value: (_17 = (_16 = (_15 = item.CreditBureauData) === null || _15 === void 0 ? void 0 : _15.Analysis) === null || _16 === void 0 ? void 0 : _16.CurrentPaydexScore) !== null && _17 !== void 0 ? _17 : '--' },
                        { label: 'Days Beyond Terms', value: (_20 = (_19 = (_18 = item.CreditBureauData) === null || _18 === void 0 ? void 0 : _18.Analysis) === null || _19 === void 0 ? void 0 : _19.DaysBeyondTerms) !== null && _20 !== void 0 ? _20 : '--' },
                        { label: 'Total Trade Experiences', value: (_23 = (_22 = (_21 = item.CreditBureauData) === null || _21 === void 0 ? void 0 : _21.Analysis) === null || _22 === void 0 ? void 0 : _22.TotalTradeExperiences) !== null && _23 !== void 0 ? _23 : '--' },
                    ]
                },
                {
                    groupName: 'Messages',
                    items: __spreadArray([
                        { label: 'Transaction ID', value: (_25 = (_24 = item.ResponseMessage) === null || _24 === void 0 ? void 0 : _24.TxId) !== null && _25 !== void 0 ? _25 : '--' },
                        { label: 'Transaction Status', value: (_27 = (_26 = item.ResponseMessage) === null || _26 === void 0 ? void 0 : _26.TxStatus) !== null && _27 !== void 0 ? _27 : '--' }
                    ], (((_29 = (_28 = item.ResponseMessage) === null || _28 === void 0 ? void 0 : _28.Info) === null || _29 === void 0 ? void 0 : _29.Text) ? [{ label: 'Info', value: item.ResponseMessage.Info.Text }] : []), true)
                },
            ];
        case 'ES':
            return [
                { label: 'Customer Number', value: item.CustomerNumber != null && item.CustomerNumber != "" ? item.CustomerNumber : '--' },
                { label: 'Date Requested', value: item.DateRequested ? moment(item.DateRequested).format('MM-DD-YYYY') : '--', },
            ];
        case 'MidDesk':
            return [
                { label: 'File Name', value: (_30 = item.FileName) !== null && _30 !== void 0 ? _30 : '--' },
                { label: 'Created Date', value: item.CreatedDate ? moment(item.CreatedDate).format('MM-DD-YYYY') : '--', },
            ];
        default:
            return [];
    }
};
var isGroupedData = function (data) {
    return data.length > 0 && 'items' in data[0];
};
var formatWriteUpValue = function (value) {
    if (value === null || value === undefined || value === '') {
        return 'N/A';
    }
    return String(value);
};
var formatCurrencyValue = function (value) {
    if (value === null || value === undefined || value === '') {
        return '--';
    }
    var numericValue = typeof value === 'string' ? Number(value) : value;
    if (Number.isNaN(numericValue)) {
        return '--';
    }
    return "$".concat(numericValue.toLocaleString());
};
var formatPercentageFromAmounts = function (part, whole) {
    if (part === null || part === undefined || part === '' || whole === null || whole === undefined || whole === '') {
        return '--';
    }
    var partValue = typeof part === 'string' ? Number(part) : part;
    var wholeValue = typeof whole === 'string' ? Number(whole) : whole;
    if (!wholeValue || Number.isNaN(partValue) || Number.isNaN(wholeValue)) {
        return '--';
    }
    return "".concat(((partValue / wholeValue) * 100).toFixed(2), "%");
};
var flattenWriteUpSections = function (sections) {
    return sections.flatMap(function (section) { return section.lines; }).filter(Boolean);
};
var formatWriteUpMetric = function (value, fieldLabel) {
    if (value === '--') {
        return 'N/A';
    }
    return value;
};
var buildGenericWriteUpContent = function (templateLines, values) {
    var wrapDisplayValue = function (value) { return "[[".concat(value, "]]"); };
    return templateLines
        .map(function (line) { return line.replace(/{{\s*([\w]+)\s*}}/g, function (_, key) { var _a; return wrapDisplayValue((_a = values[key]) !== null && _a !== void 0 ? _a : "{{".concat(key, "}}")); }); })
        .join('\n');
};
var stripWriteUpMarkers = function (content) {
    return content.replace(/\[\[([\s\S]*?)\]\]/g, '$1');
};
var renderWriteUpLineParts = function (line, lineIdx) {
    var parts = line.split(/(\[\[[\s\S]*?\]\])/g);
    return parts.map(function (part, partIdx) {
        var isMarkedValue = /^\[\[[\s\S]*\]\]$/.test(part);
        if (isMarkedValue) {
            var value = part.replace(/^\[\[/, '').replace(/\]\]$/, '');
            return React.createElement("strong", { key: "part-".concat(lineIdx, "-").concat(partIdx) }, value);
        }
        return React.createElement(React.Fragment, { key: "part-".concat(lineIdx, "-").concat(partIdx) }, part);
    });
};
var renderWriteUpContent = function (content) {
    var lines = content.split('\n').filter(function (line) { return line.trim().length > 0; });
    return lines.map(function (line, lineIdx) {
        var isBulletLine = line.trim().startsWith('- ');
        var lineContent = isBulletLine ? line.trim().slice(2) : line;
        if (isBulletLine) {
            return (React.createElement(Box, { key: "line-".concat(lineIdx), sx: {
                    display: 'flex',
                    alignItems: 'flex-start',
                    mb: 0.75,
                } },
                React.createElement(Box, { component: "span", sx: { mr: 1 } }, "\u2022"),
                React.createElement(Box, { component: "span", sx: { flex: 1 } }, renderWriteUpLineParts(lineContent, lineIdx))));
        }
        return (React.createElement(Box, { key: "line-".concat(lineIdx), component: "div", sx: { mb: lineIdx < lines.length - 1 ? 0.75 : 0 } }, renderWriteUpLineParts(lineContent, lineIdx)));
    });
};
var payNetWriteUpTemplate = [
    '- The report reflects a Master Score of {{masterScore}} which is in the {{percentile}} percentile',
    '- The Original Gross Receivable was {{originalGrossReceivable}}. The Highest Credit Ever was {{highestCreditEver}}, and the Percent receivable outstanding was {{currentBalanceAmount}} with {{currentBalancePastDue31PlusAmount}} past due. Payment Summary sections reflect {{scheduledPayments}} installments made with {{pastDue31PlusCombined}}, {{pastDue3160Combined}}, {{pastDue6190Combined}}, {{pastDue91PlusCombined}}.',
    '- The Average high credit per lender was {{averageHighCreditPerLender}}; the Average Term has been {{averageTerm}} Months; {{openContractsCount}} open contracts and {{closedContractsCount}} closed. The single lender high credits over {{singleLenderHighCredit}}.',
];
var equifaxWriteUpTemplate = [
    'An Equifax credit report shows {{totalTrades}} trades. {{currentTrades}} of them are current and {{negativeTradesHistory}} prior negative trades.',
    'The report returned a FICO score of {{ficoScore}}, with a {{highCredit}} high credit, {{amountPastDue}} amount past due including {{mortgageDebt}} in mortgage debt.',
    '{{totalInstallmentBalance}} installment debt and a {{revolvingBalance}} revolving balance with {{availableAmount}} available.',
    'Oldest trade is {{oldestTrade}}. SSN issued in {{ssnYearIssued}} in {{ssnStateIssued}}.',
    'Slow pay history of - ({{currentRating30}}) x 30, ({{currentRating60}}) x 60, ({{currentRating90}}) x 90',
];
var dnbWriteUpTemplate = [
    '- The Firm has a Paydex of {{paydex}} which reflects payments which are {{daysBeyondTerms}} days beyond terms vs {{industryPaydex}} and {{industryDaysBeyond}} days beyond for the industry',
    '- The company illustrates a Delinquency score of {{delinquencyScore}} and {{delinquencyPercentile}} Percentile which is evidence of {{delinquencyRisk}} risk of sever delinquency.',
    '- The failure score is {{failureScore}} and {{failurePercent}}, {{failureRisk}} compared to {{dbAveragePercent}} in D&B’s database average.',
    '- {{tradeExperiences}} trade experiences. Highest credit: {{highestCredit}}, average high credit: {{averageHighCredit}}. {{withinTermsPercent}} within terms, {{pastDueAmount}} past due.',
    '- {{suits}} suits, {{liens}} liens, {{judgements}} judgements',
];
var getTemplatePayload = function (writeUpData) {
    if (writeUpData.dnbMetrics) {
        var dnb = writeUpData.dnbMetrics;
        return {
            template: dnbWriteUpTemplate,
            values: {
                paydex: formatWriteUpMetric(dnb.paydex, 'Paydex'),
                daysBeyondTerms: formatWriteUpMetric(dnb.daysBeyondTerms, 'Days Beyond Terms'),
                industryPaydex: formatWriteUpMetric(dnb.industryPaydex, 'Industry Paydex'),
                industryDaysBeyond: formatWriteUpMetric(dnb.industryDaysBeyond, 'Industry Days Beyond'),
                delinquencyScore: formatWriteUpMetric(dnb.delinquencyScore, 'Delinquency Score'),
                delinquencyPercentile: formatWriteUpMetric(dnb.delinquencyPercentile, 'Delinquency Percentile'),
                delinquencyRisk: formatWriteUpMetric(dnb.delinquencyRisk, 'Delinquency Risk'),
                failureScore: formatWriteUpMetric(dnb.failureScore, 'Failure Score'),
                failurePercent: formatWriteUpMetric(dnb.failurePercent, 'Failure Percent'),
                failureRisk: formatWriteUpMetric(dnb.failureRisk, 'Failure Risk'),
                dbAveragePercent: formatWriteUpMetric(dnb.dbAveragePercent, 'DB Average'),
                tradeExperiences: formatWriteUpMetric(dnb.tradeExperiences, 'Trade Experiences'),
                highestCredit: formatWriteUpMetric(dnb.highestCredit, 'Highest Credit'),
                averageHighCredit: formatWriteUpMetric(dnb.averageHighCredit, 'Average High Credit'),
                withinTermsPercent: formatWriteUpMetric(dnb.withinTermsPercent, 'Within Terms'),
                pastDueAmount: formatWriteUpMetric(dnb.pastDueAmount, 'Past Due Amount'),
                suits: formatWriteUpMetric(dnb.suits, 'Suits'),
                liens: formatWriteUpMetric(dnb.liens, 'Liens'),
                judgements: formatWriteUpMetric(dnb.judgements, 'Judgements'),
            },
        };
    }
    if (writeUpData.equifaxMetrics) {
        var equifax = writeUpData.equifaxMetrics;
        return {
            template: equifaxWriteUpTemplate,
            values: {
                totalTrades: formatWriteUpMetric(equifax.totalTrades, 'Total Trades'),
                currentTrades: formatWriteUpMetric(equifax.currentTrades, 'Current Trades'),
                negativeTradesHistory: formatWriteUpMetric(equifax.negativeTradesHistory, 'Negative Trades'),
                currentRating30: formatWriteUpMetric(equifax.currentRating30, 'Occurrences 30'),
                currentRating60: formatWriteUpMetric(equifax.currentRating60, 'Occurrences 60'),
                currentRating90: formatWriteUpMetric(equifax.currentRating90, 'Occurrences 90'),
                ficoScore: formatWriteUpMetric(equifax.ficoScore, 'FICO Score'),
                highCredit: formatWriteUpMetric(equifax.highCredit, 'High Credit'),
                amountPastDue: formatWriteUpMetric(equifax.amountPastDue, 'Amount Past Due'),
                mortgageDebt: formatWriteUpMetric(equifax.mortgageDebt, 'Mortgage Debt'),
                totalInstallmentBalance: formatWriteUpMetric(equifax.totalInstallmentBalance, 'Total Installment Balance'),
                revolvingBalance: formatWriteUpMetric(equifax.revolvingBalance, 'Revolving Balance'),
                availableAmount: formatWriteUpMetric(equifax.availableAmount, 'Available Amount'),
                oldestTrade: formatWriteUpMetric(equifax.oldestTrade, 'Oldest Trade'),
                ssnYearIssued: formatWriteUpMetric(equifax.ssnYearIssued, 'SSN Year Issued'),
                ssnStateIssued: formatWriteUpMetric(equifax.ssnStateIssued, 'SSN State Issued'),
            },
        };
    }
    if (writeUpData.payNetMetrics) {
        var payNet_1 = writeUpData.payNetMetrics;
        return {
            template: payNetWriteUpTemplate,
            values: {
                masterScore: formatWriteUpMetric(payNet_1.masterScore, 'Master Score'),
                percentile: formatWriteUpMetric(payNet_1.percentile, 'Percentile'),
                originalGrossReceivable: formatWriteUpMetric(payNet_1.originalGrossReceivable, 'Original Gross Receivable'),
                highestCreditEver: formatWriteUpMetric(payNet_1.highestCreditEver, 'Highest Credit Ever'),
                currentBalanceAmount: formatWriteUpMetric(payNet_1.currentBalanceAmount, 'Current Balance Amount'),
                currentBalancePastDue31PlusAmount: formatWriteUpMetric(payNet_1.currentBalancePastDue31PlusAmount, 'Current Balance Past Due'),
                scheduledPayments: formatWriteUpMetric(payNet_1.scheduledPayments, 'Scheduled Payments'),
                pastDue31PlusCombined: (function () { var o = formatWriteUpMetric(payNet_1.pastDue31PlusOccurrences, '31+ Occurrences'); return "".concat(o, " x 31+"); })(),
                pastDue3160Combined: (function () { var o = formatWriteUpMetric(payNet_1.pastDue3160Occurrences, '31-60 Occurrences'); var d = payNet_1.mostRecentPastDue3160Date !== '--' ? " (".concat(payNet_1.mostRecentPastDue3160Date, ")") : ''; return "".concat(o, " x 31-60").concat(d); })(),
                pastDue6190Combined: (function () { var o = formatWriteUpMetric(payNet_1.pastDue6190Occurrences, '61-90 Occurrences'); var d = payNet_1.mostRecentPastDue6190Date !== '--' ? " (".concat(payNet_1.mostRecentPastDue6190Date, ")") : ''; return "".concat(o, " x 61-90").concat(d); })(),
                pastDue91PlusCombined: (function () { var o = formatWriteUpMetric(payNet_1.pastDue91PlusOccurrences, '91+ Occurrences'); var d = payNet_1.mostRecentPastDue91PlusDate !== '--' ? " (".concat(payNet_1.mostRecentPastDue91PlusDate, ")") : ''; return "".concat(o, " x 91+").concat(d); })(),
                averageHighCreditPerLender: formatWriteUpMetric(payNet_1.averageHighCreditPerLender, 'Average High Credit Per Lender'),
                averageTerm: formatWriteUpMetric(payNet_1.averageTerm, 'Average Term'),
                openContractsCount: formatWriteUpMetric(payNet_1.openContractsCount, 'Open Contracts Count'),
                closedContractsCount: formatWriteUpMetric(payNet_1.closedContractsCount, 'Closed Contracts Count'),
                singleLenderHighCredit: formatWriteUpMetric(payNet_1.singleLenderHighCredit, 'Single Lender High Credit'),
            },
        };
    }
    return null;
};
var createWriteUpData = function (section, data, roleType) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    var reportTitle = section.BureauCode === 'MidDesk' ? 'MidDesk' : section.CreditBureau || 'Credit Bureau';
    var reportSubtitle = 'LegalName' in section ? section.LegalName || '' : '';
    var reportDate = 'DateRequested' in section && section.DateRequested
        ? moment(section.DateRequested).format('MM-DD-YYYY')
        : '--';
    var sections = isGroupedData(data)
        ? data.map(function (group) { return ({
            title: group.groupName,
            lines: group.items.map(function (item) { return "".concat(item.label, ": ").concat(formatWriteUpValue(item.value)); }),
        }); })
        : [{
                lines: data.map(function (item) { return "".concat(item.label, ": ").concat(formatWriteUpValue(item.value)); }),
            }];
    var writeUpData = {
        title: reportTitle,
        subtitle: reportSubtitle,
        bureauCode: section.BureauCode,
        dateRequested: reportDate,
        sections: sections,
    };
    if (PAYNET_CODES.includes(section.BureauCode)) {
        var payNetSection = section;
        var currentBalanceAmount = payNetSection.CurrentBalanceAmount != null && payNetSection.CurrentBalanceAmount !== ''
            ? payNetSection.CurrentBalanceAmount
            : payNetSection.TotalOutstandingReceivable;
        writeUpData.payNetMetrics = {
            masterScore: formatWriteUpValue(payNetSection.MasterScore),
            percentile: formatWriteUpValue(payNetSection.Percentile),
            originalGrossReceivable: formatCurrencyValue(payNetSection.OriginalGrossReceivable),
            highestCreditEver: formatCurrencyValue(payNetSection.HighestCreditEver),
            currentBalanceAmount: formatCurrencyValue(currentBalanceAmount),
            currentBalancePercent: formatPercentageFromAmounts(payNetSection.TotalOutstandingReceivable, payNetSection.OriginalGrossReceivable),
            currentBalancePastDue31PlusAmount: formatCurrencyValue(payNetSection.CurrentBalancePastDue31PlusAmount),
            scheduledPayments: formatWriteUpValue(payNetSection.ScheduledPayments),
            pastDue31PlusOccurrences: formatWriteUpValue(payNetSection.PastDue31PlusOccurrences),
            pastDue3160Occurrences: formatWriteUpValue(payNetSection.PastDue3160Occurrences),
            mostRecentPastDue3160Date: payNetSection.MostRecentPastDue3160Date
                ? moment(payNetSection.MostRecentPastDue3160Date).format('MM-DD-YYYY')
                : '--',
            pastDue6190Occurrences: formatWriteUpValue(payNetSection.PastDue6190Occurrences),
            mostRecentPastDue6190Date: payNetSection.MostRecentPastDue6190Date
                ? moment(payNetSection.MostRecentPastDue6190Date).format('MM-DD-YYYY')
                : '--',
            pastDue91PlusOccurrences: formatWriteUpValue(payNetSection.PastDue91PlusOccurrences),
            mostRecentPastDue91PlusDate: payNetSection.MostRecentPastDue91PlusDate
                ? moment(payNetSection.MostRecentPastDue91PlusDate).format('MM-DD-YYYY')
                : '--',
            averageHighCreditPerLender: formatCurrencyValue(payNetSection.AverageHighCreditPerLendar),
            averageTerm: formatWriteUpValue(payNetSection.AverageTerm),
            openContractsCount: formatWriteUpValue(payNetSection.OpenContractsCount),
            closedContractsCount: formatWriteUpValue(payNetSection.ClosedContractsCount),
            singleLenderHighCredit: formatCurrencyValue(payNetSection.HighestAmountBorrowedFromOneLender),
        };
    }
    if (section.BureauCode === 'DB') {
        writeUpData.dnbMetrics = {
            paydex: formatWriteUpValue((_c = (_b = (_a = section.CreditBureauData) === null || _a === void 0 ? void 0 : _a.Analysis) === null || _b === void 0 ? void 0 : _b.CurrentPaydexScore) !== null && _c !== void 0 ? _c : ''),
            daysBeyondTerms: formatWriteUpValue((_f = (_e = (_d = section.CreditBureauData) === null || _d === void 0 ? void 0 : _d.Analysis) === null || _e === void 0 ? void 0 : _e.DaysBeyondTerms) !== null && _f !== void 0 ? _f : ''),
            industryPaydex: formatWriteUpValue((_h = (_g = section.BusinessWorkSheet) === null || _g === void 0 ? void 0 : _g.CreditReportScore) !== null && _h !== void 0 ? _h : ''),
            industryDaysBeyond: '--',
            delinquencyScore: formatWriteUpValue((_l = (_k = (_j = section.CreditBureauData) === null || _j === void 0 ? void 0 : _j.Analysis) === null || _k === void 0 ? void 0 : _k.CreditRiskScore) !== null && _l !== void 0 ? _l : ''),
            delinquencyPercentile: formatWriteUpValue((_p = (_o = (_m = section.CreditBureauData) === null || _m === void 0 ? void 0 : _m.BusinessData) === null || _o === void 0 ? void 0 : _o.RiskScorePercentile) !== null && _p !== void 0 ? _p : ''),
            delinquencyRisk: formatWriteUpValue((_s = (_r = (_q = section.CreditBureauData) === null || _q === void 0 ? void 0 : _q.Analysis) === null || _r === void 0 ? void 0 : _r.ReportRating) !== null && _s !== void 0 ? _s : ''),
            failureScore: formatWriteUpValue((_v = (_u = (_t = section.CreditBureauData) === null || _t === void 0 ? void 0 : _t.Analysis) === null || _u === void 0 ? void 0 : _u.CommercialCreditScore) !== null && _v !== void 0 ? _v : ''),
            failurePercent: '--',
            failureRisk: formatWriteUpValue((_y = (_x = (_w = section.CreditBureauData) === null || _w === void 0 ? void 0 : _w.Analysis) === null || _x === void 0 ? void 0 : _x.ReportRating) !== null && _y !== void 0 ? _y : ''),
            dbAveragePercent: '--',
            tradeExperiences: formatWriteUpValue((_0 = (_z = section.BusinessWorkSheet) === null || _z === void 0 ? void 0 : _z.WeightedScorecardBusinessCount) !== null && _0 !== void 0 ? _0 : ''),
            highestCredit: '--',
            averageHighCredit: '--',
            withinTermsPercent: '--',
            pastDueAmount: '--',
            suits: '--',
            liens: '--',
            judgements: '--',
        };
    }
    if (EQUIFAX_CODES.includes(section.BureauCode)) {
        var equifaxSection = section;
        var ficoScoreValue = getRoleBasedEquifaxFicoScore(equifaxSection, roleType);
        writeUpData.equifaxMetrics = {
            totalTrades: formatWriteUpValue(equifaxSection.TotalTrades),
            currentTrades: formatWriteUpValue(equifaxSection.CurrentTrades),
            currentRating30: formatWriteUpValue(equifaxSection.CURRENTRATING_30),
            currentRating60: formatWriteUpValue(equifaxSection.CURRENTRATING_60),
            currentRating90: formatWriteUpValue(equifaxSection.CURRENTRATING_90),
            negativeTradesHistory: formatWriteUpValue(equifaxSection.NegativeTradesHistory),
            ficoScore: formatWriteUpValue(ficoScoreValue),
            highCredit: formatCurrencyValue(equifaxSection.HighCredit),
            amountPastDue: formatCurrencyValue(equifaxSection.AmountPastDue),
            mortgageDebt: formatCurrencyValue(equifaxSection.RealEstateBalance),
            totalInstallmentBalance: formatCurrencyValue(equifaxSection.InstallmentBalance),
            revolvingBalance: formatCurrencyValue(equifaxSection.RevolvingBalance),
            availableAmount: equifaxSection.AvailablePercentage != null && equifaxSection.AvailablePercentage !== ''
                ? "".concat(equifaxSection.AvailablePercentage, "%")
                : '--',
            oldestTrade: formatWriteUpValue(equifaxSection.OldestTrade),
            ssnYearIssued: formatWriteUpValue(equifaxSection.ssnIssuedYear),
            ssnStateIssued: formatWriteUpValue(equifaxSection.ssnIssuedState),
        };
    }
    return writeUpData;
};
var buildWriteUpContent = function (writeUpData) {
    var templatePayload = getTemplatePayload(writeUpData);
    if (templatePayload) {
        return buildGenericWriteUpContent(templatePayload.template, templatePayload.values);
    }
    var summaryLines = flattenWriteUpSections(writeUpData.sections);
    var reportNameText = writeUpData.subtitle ? " for ".concat(writeUpData.subtitle) : '';
    var summaryText = summaryLines.length > 0 ? summaryLines.join(', ') : 'No additional details were available.';
    return "The ".concat(writeUpData.title, " report").concat(reportNameText, " was requested on ").concat(writeUpData.dateRequested, ". Summary details include ").concat(summaryText, ".");
};
var Reports = function (_a) {
    var TxAspireOId = _a.TxAspireOId, _b = _a.creditReportItems, creditReportItems = _b === void 0 ? [] : _b, onCreditReportOpen = _a.onCreditReportOpen;
    var roleType = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleType; });
    var _c = useState([]), reports = _c[0], setReports = _c[1];
    var _d = useState({
        open: false,
        title: '',
        subtitle: '',
        content: '',
    }), writeUpDialog = _d[0], setWriteUpDialog = _d[1];
    var _e = useState(false), isWriteUpCopied = _e[0], setIsWriteUpCopied = _e[1];
    var fetchCreditReports = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, fetchedReports, sortedReports, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, api_service.get({
                            endPoint: api_urls.BACKLOG_APPLICATION_CREDIT_REPORTS,
                            payLoad: { TxAspireOId: TxAspireOId, "View": "JSON" },
                        })];
                case 1:
                    res = _b.sent();
                    fetchedReports = ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) || [];
                    sortedReports = fetchedReports.sort(function (a, b) {
                        if (a.BureauCode === 'MidDesk')
                            return -1;
                        if (b.BureauCode === 'MidDesk')
                            return 1;
                        return 0;
                    });
                    setReports(sortedReports || []);
                    return [3, 3];
                case 2:
                    error_1 = _b.sent();
                    console.error('fetchCreditReports error:', error_1);
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); };
    useEffect(function () {
        if (!TxAspireOId)
            return;
        fetchCreditReports();
    }, [TxAspireOId]);
    var findReportItem = function (section, index) {
        var _a;
        var sectionOId = section === null || section === void 0 ? void 0 : section.CreditReportOId;
        if (sectionOId) {
            var byId = creditReportItems.find(function (item) { return String(item === null || item === void 0 ? void 0 : item.CreditReportOId) === String(sectionOId); });
            if (byId)
                return byId;
        }
        var sameBureau = creditReportItems.filter(function (item) { return (item === null || item === void 0 ? void 0 : item.BureauCode) === section.BureauCode; });
        var occurrence = reports.slice(0, index).filter(function (report) { return report.BureauCode === section.BureauCode; }).length;
        return (_a = sameBureau[occurrence]) !== null && _a !== void 0 ? _a : sameBureau[0];
    };
    var openWriteUpDialog = function (section, data) {
        var writeUpData = createWriteUpData(section, data, roleType);
        var content = buildWriteUpContent(writeUpData);
        setIsWriteUpCopied(false);
        setWriteUpDialog({
            open: true,
            title: writeUpData.title,
            subtitle: writeUpData.subtitle,
            content: content,
        });
    };
    var closeWriteUpDialog = function () {
        setIsWriteUpCopied(false);
        setWriteUpDialog({ open: false, title: '', subtitle: '', content: '' });
    };
    var copyWriteUpContent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var textArea, error_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    if (!((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) return [3, 2];
                    return [4, navigator.clipboard.writeText(stripWriteUpMarkers(writeUpDialog.content))];
                case 1:
                    _b.sent();
                    return [3, 3];
                case 2:
                    textArea = document.createElement('textarea');
                    textArea.value = stripWriteUpMarkers(writeUpDialog.content);
                    textArea.style.position = 'fixed';
                    textArea.style.opacity = '0';
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textArea);
                    _b.label = 3;
                case 3:
                    setIsWriteUpCopied(true);
                    setTimeout(function () {
                        setIsWriteUpCopied(false);
                    }, 2000);
                    return [3, 5];
                case 4:
                    error_2 = _b.sent();
                    utility.alert('Unable to copy write-up. Please try again.', 'error');
                    console.error('copyWriteUpContent error:', error_2);
                    return [3, 5];
                case 5: return [2];
            }
        });
    }); };
    return (React.createElement(Stack, { gap: 2 },
        reports.length === 0 ? (React.createElement(TabSectionCard, { title: "Reports", showEditIcon: false, showSaveCancel: false },
            React.createElement(Box, { sx: { textAlign: 'center', py: 4 } },
                React.createElement(Typography, { fontSize: "14px", color: "#4F4F4F" }, "No reports available.")))) : (reports.map(function (section, index) {
            var data = prepareDataByBureau(section, roleType);
            var isGrouped = isGroupedData(data);
            return (React.createElement(TabSectionCard, { key: index, title: section.BureauCode === 'MidDesk' ? 'MidDesk' : section.CreditBureau, chip: section.BureauCode !== 'MidDesk' && 'DisplayName' in section ? section.DisplayName || undefined : undefined, showEditIcon: false, showSaveCancel: false, headerActions: (React.createElement(Typography, { component: "button", type: "button", variant: "body2", onClick: function () { var _a; return onCreditReportOpen === null || onCreditReportOpen === void 0 ? void 0 : onCreditReportOpen((_a = findReportItem(section, index)) !== null && _a !== void 0 ? _a : section); }, sx: {
                        background: 'none',
                        border: 'none',
                        p: 0,
                        cursor: 'pointer',
                        fontWeight: 600,
                        textDecoration: 'underline',
                        color: baseColors.successPreset[30],
                        '&:hover': { color: baseColors.successPreset[10] },
                    } }, "View Report")) },
                section.BureauCode !== 'MidDesk' && section.BureauCode !== 'ES' && (React.createElement(Box, { sx: { display: 'flex', justifyContent: 'flex-end', mb: 2 } },
                    React.createElement(Button, { variant: "text", size: "small", onClick: function () { return openWriteUpDialog(section, data); } }, "Click here for write-up"))),
                React.createElement(Grid, { container: true, spacing: 2, alignItems: 'end', sx: RESPONSIVE_FIELD_GRID_SX }, isGrouped ? (data.map(function (group, groupIdx) { return (React.createElement(React.Fragment, { key: groupIdx },
                    group.groupName && (React.createElement(React.Fragment, null,
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Divider, null)),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Typography, { variant: 'subtitle2', sx: { color: baseColors.bluePreset[100], letterSpacing: '1.25px' } }, group.groupName)))),
                    group.items.map(function (item, idx) { return (React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, key: "".concat(groupIdx, "-").concat(idx) },
                        React.createElement(DataWrapper, { gap: 1 },
                            React.createElement(Typography, { variant: "caption", className: "title" },
                                item.label,
                                ":"),
                            React.createElement(TruncatedTooltipText, { value: item.value })))); }))); })) : (data.map(function (item, idx) { return (React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 4, key: idx },
                    React.createElement(DataWrapper, { gap: 1 },
                        React.createElement(Typography, { variant: "caption", className: "title" },
                            item.label,
                            ":"),
                        React.createElement(TruncatedTooltipText, { value: item.value })))); })))));
        })),
        React.createElement(CommonDialog, { open: writeUpDialog.open, onClose: closeWriteUpDialog, maxWidth: "md", fullWidth: true, dialogTitle: (React.createElement(Box, { display: "flex", alignItems: "center" },
                React.createElement(Typography, { variant: "body1", fontWeight: 600, color: "#1F275C" }, writeUpDialog.title || 'Write-Up'),
                writeUpDialog.subtitle && (React.createElement(React.Fragment, null,
                    React.createElement("span", { style: { marginRight: 4, marginLeft: 4 } }, "-"),
                    React.createElement(Chip, { label: writeUpDialog.subtitle, variant: "filled", size: "small", sx: { ml: 0.5, fontWeight: 400, backgroundColor: '#d3e3fd' } }))))), showCloseIcon: false, headerActions: (React.createElement(Tooltip, { title: isWriteUpCopied ? 'Copied' : 'Copy write-up' },
                React.createElement(IconButton, { "aria-label": isWriteUpCopied ? 'Copied' : 'Copy write-up', onClick: copyWriteUpContent }, isWriteUpCopied ? React.createElement(CheckIcon, { sx: { color: 'success.main' } }) : React.createElement(ContentCopyIcon, null)))) },
            React.createElement(Box, { sx: { mt: 2 } },
                React.createElement(Typography, { component: "div", sx: {
                        wordBreak: 'break-word',
                        fontFamily: 'inherit',
                        fontSize: '14px',
                        color: '#4F4F4F',
                        margin: 0,
                        lineHeight: 1.6,
                    } }, renderWriteUpContent(writeUpDialog.content)),
                React.createElement(Box, { sx: { display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 } },
                    React.createElement(Button, { variant: "outlined", onClick: closeWriteUpDialog }, "Close"))))));
};
export default Reports;
